import { filterStartsWith } from '@/utils/shared'
export default {
  id: 'parts',
  mode: {
    isModalNew: true
  },
  store: {
    get: {
      url: 'Parts/GetAllDynamic',
      selected: 'id,partNumber,partDescription,listPrice,currency.title as priceCurrency,listPriceDate,remark,technicalRemark,manufacturer.name as manufacturerName'
    },
    create: {
      url: 'Parts/Create'
    },
    patch: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'Parts/Patch/${data.id}'
    },
    delete: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'Parts/Delete/${data.id}',
      modal: {
        msgDataKey: 'partNumber'
      }
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('part-number')}",
      field: 'partNumber',
      editor: {
        type: 'string',
        required: true
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("part-description")}',
      field: 'partDescription',
      editor: {
        type: 'string',
        required: true
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('manufacturer-name')}",
      field: 'manufacturerName',
      sortable: {
        custom: 'manufacturer.name'
      },
      editor: {
        type: 'select',
        required: true,
        field: 'manufacturerID',
        value: 'id',
        data: {
          url: 'Companies/GetAllDynamic',
          selected: 'id,name'
        },
        // eslint-disable-next-line no-template-curly-in-string
        filterTemplate: 'name.contains("${data}")',
        remote: true,
        option: {
          label: 'name'
        }
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("list-price")}',
      field: 'listPrice',
      editor: {
        type: 'number'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("price-currency")}',
      field: 'priceCurrency',
      sortable: {
        custom: 'currency.title'
      },
      editor: {
        type: 'select',
        field: 'priceCurrencyID',
        value: 'id',
        data: 'Currencies/GetAllDynamic?select=id,title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("list-price-date")}',
      field: 'listPriceDate',
      template: 'date',
      editor: {
        type: 'date',
        field: 'listPriceDate'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("remark")}',
      field: 'remark',
      sortable: {
        isAvailable: false
      },
      editor: {
        type: 'string'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("technical-remark")}',
      field: 'technicalRemark',
      sortable: {
        isAvailable: false
      },
      editor: {
        type: 'string'
      }
    }
  ],
  rowControls: {
    right: {
      classes: 'controls-inline',
      controls: [
        {
          type: 'edit'
        },
        {
          type: 'custom',
          // eslint-disable-next-line no-template-curly-in-string
          title: '${root.L10n("quick-rfq")}',
          permission: 'isAllowToEditRFQs'
        }
      ]
    }
  },
  header: {
    controls: {
      isVisible: true,
      export: {
        json: {
          current: {
            isVisible: false
          },
          all: {
            isVisible: false
          }
        }
      },
      addNew: {
        permission: 'isAllowToEditParts'
      }
    }
  },
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          valueTemplate: 'partNumber.contains("${data.value}") || partDescription.contains("${data.value}")',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('search')}",
          styles: {
            minWidth: '17rem'
          }
        }
      },
      {
        type: 'selectautocomplete',
        field: 'id',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("part")}',
        options: {
          dataSource: {
            url: 'Parts/GetAllDynamic',
            selected: 'id,partNumber,partDescription,remark'
          },
          searchAllColumns: true,
          columns: [
            {
              // eslint-disable-next-line no-template-curly-in-string
              title: "${root.L10n('part-number')}",
              value: 'partNumber',
              originField: 'partNumber',
              type: 'custom',
              customFilter: filterStartsWith
            },
            {
              // eslint-disable-next-line no-template-curly-in-string
              title: "${root.L10n('part-description')}",
              value: 'partDescription',
              originField: 'partDescription',
              type: 'custom',
              customFilter: filterStartsWith
            }
          ],
          option: {
            label: 'partNumber'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('select-part-number')}"
        }
      }
    ]
  },
  permission: {
    edit: 'isAllowToEditParts'
  }
}
